import {getmenus} from '../../api/login.js'
export default{
    state:{
        name:'app',
        eseCode:localStorage.getItem('eseCode')||'',//企业code 
        iframeState:false,//iframe容器是否显示
        iframUrl:'',//初始时的iframeUrl的值
        breakFirst:localStorage.getItem('breakFirst')||'主页',
        breakTwo:localStorage.getItem('breakTwo')||'',
        homePage:{
            menus:JSON.parse(localStorage.getItem('homePagemenus'))||''//菜单
        }
    },
    getters: {
        // 获得企业code 
        geteseCode(state){
            return state.eseCode
             
        },
        // 面包屑
        getbreakFirst(state){
            return state.breakFirst
        },
        getbreakTwo(state){
            return state.breakTwo
        },
        getappName(state){
            return state.name
        },
        getIframeState(state){
            return state.iframeState

        },
        getIframeUrl(state){
            return state.iframUrl
        },
        // 菜单
        getMenu(state){
            return state.homePage.menus
        }

    },
    mutations:{
        // 设置企业code
        seteseCode(state,value){
            state.eseCode = value
        },
        //设置面包屑
        setbreakFirst(state,value){
            state.breakFirst = value
        },
        setbreakTwo(state,value){
            state.breakTwo = value
        },
        setIframeState(state,value){
            state.iframeState=value    
        },
        setIframeUrl(state,url){
            state.iframUrl=url
        },
        // 处理菜单
         setpageMenus(state,data){
             localStorage.setItem("homePagemenus",JSON.stringify(data))
             state.homePage.menus = data

         }
    },
    actions:{
        // 获取菜单
        getHomepageMenus({commit},userId){
          return new Promise((resolve,reject)=>{
            let hasdealData = []
            getmenus({
                 userId
             }).then(res=>{
                 console.log(res)
                if(res.data.code==1000){
                    let resultData = res.data.data
                    for(const role of resultData){
                        if(role.parentId==0){
                            let fathermenu = JSON.parse(JSON.stringify(role))
                            fathermenu.children =[]
                            for(var childrens of resultData){
                                 if(childrens.parentId == role.id){
                                     let childmenu = JSON.parse(JSON.stringify(childrens))
                                     fathermenu.children.push(childmenu)
                                 }

                            }
                            hasdealData.push(fathermenu)
                            // console.log(hasdealData)
                        }
                    }
                    commit('setpageMenus',hasdealData)
                    console.log(hasdealData,'菜单信息')
                    localStorage.setItem('menuAll',hasdealData);
                    localStorage.setItem("isShow",'true')
                }else{
                    localStorage.setItem("isShow",'false')
                    alert(res.data.msg);
                }
                 resolve(hasdealData)
             }).catch((err)=>{
                 reject(err)
                 localStorage.setItem("isShow",'false')
             })
          })
        },
   
    }
}


// WEBPACK FOOTER //
// ./src/store/module/app.js